<template>
    <svg
        width="65"
        height="29"
        viewBox="0 0 65 29"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.89566 7.72568V11.3634H15.5845V18.9698H7.89566V27.9812H0V0.078125H16.7833L17.3207 7.72568H7.89566Z"
        />
        <path
            d="M39.8588 4.37003C42.4782 7.04376 43.7887 10.2714 43.7887 14.0522C43.7887 17.8603 42.4781 21.1011 39.8588 23.7752C37.239 26.4488 34.0793 27.7856 30.3794 27.7856C26.6524 27.7856 23.4786 26.4488 20.8593 23.7752C18.2393 21.1012 16.9297 17.8603 16.9297 14.0522C16.9297 10.2713 18.2393 7.04376 20.8593 4.37003C23.4786 1.6963 26.6524 0.359375 30.3794 0.359375C34.0791 0.359375 37.239 1.6963 39.8588 4.37003ZM28.1107 19.6427C28.1107 20.2644 28.3399 20.8043 28.7994 21.2632C29.2583 21.7228 29.8122 21.9521 30.4604 21.9521C31.1086 21.9521 31.6555 21.7228 32.1011 21.2632C32.5469 20.8043 32.7696 20.2644 32.7696 19.6427V8.3401C32.7696 7.69199 32.5469 7.13869 32.1011 6.67918C31.6556 6.22035 31.1087 5.99048 30.4604 5.99048C29.8122 5.99048 29.2584 6.22035 28.7994 6.67918C28.3398 7.13869 28.1107 7.69199 28.1107 8.3401V19.6427Z"
        />
        <path
            d="M56.1108 28.0642L52.1426 20.9952L48.2982 28.0642H39.6172L47.8849 13.5957L40.0719 0.078125H49.001L52.2668 6.11349L55.5737 0.078125H64.2132L56.5657 13.5129L64.9987 28.0641H56.1108V28.0642Z"
        />
    </svg>
</template>

<script>
export default {
    name: 'Fox'
};
</script>
